import { defineComponent, ref } from "vue";

export default defineComponent({
  props: {
    initial: {
      type: Number,
      default: 1,
    }
  },
  setup(props, { slots }) {

    const current = ref(props.initial)

    function changeItem(index: number) {
      if (index !== current.value) {
        current.value = index
      }
    }

    return () => 
      slots?.default?.({
        changeItem,
        current: current.value,
      })
  }
})